
import { extendTheme } from "@chakra-ui/react"

// Add our fonts
import '@fontsource/martel/600.css';
import '@fontsource/martel/700.css';
import '@fontsource/martel/800.css';
import '@fontsource/martel/900.css';
import '@fontsource/montserrat/500.css';
import '@fontsource/montserrat/600.css';

const theme = extendTheme({
    styles: {
        global: {
            // Anything scrolled to by id (e.g. /#contact) stops below the sticky navbar
            "[id]": {
                scrollMarginTop: "90px",
            },
        },
    },
    colors: {
        white: {
            100: "#FFFFFF",
            200: "#F9F9F9",
            300: "#FAFAFA",
            400: "#737373",
			500: "#F2F2F2", // Off-white for text
        },
        blue: {
            100: "#252C40", // Background of the site
            200: "#252B42",
            300: "#03A9F4", // Zenith blue
			400: "#414758", // Darker blue for other sections
        },
        yellow: {
            100: "#D0A144",
            200: "#FFA033",
        },
        grey: {
            100: "#C9C9C9",
            200: "#737373",
        },
    },
})

export default theme